import { onCLS, onINP, onLCP } from "web-vitals/attribution";

type VitalPayload = {
  name: string;
  value: number;
  id: string;
  rating?: string;
  page: string;
  path: string;
  attribution?: unknown;
  ts: number;
  experimentId?: string;
};

function sendVital(metric: any) {
  const payload: VitalPayload = {
    name: metric.name,
    value: metric.value,
    id: metric.id,
    rating: metric.rating,
    page: document.title,
    path: location.pathname,
    attribution: metric.attribution,
    ts: Date.now(),
    experimentId: window.localStorage.getItem("exp:current") ?? undefined,
  };

  navigator.sendBeacon("/api/rum", JSON.stringify(payload));
}

export function initWebVitals() {
  onCLS(sendVital);
  onINP(sendVital);
  onLCP(sendVital);
}
